import cuid from 'cuid';

export const FROM_TYPE = {
  TEMPLATE_PLUGIN:'template-plugin-100',
  ONLINE:'fo-online-101',
}

const MESSAGE_TYPE = {
  RESPONSE: 'response',
  REQUEST: 'request',
  EVENT: 'event',
  LISTENER: 'listener',
}

function noOp(method, data) {
  return new Promise((/* resolve, reject */)=>{
    console.log("noOp -> method, data", method, data)
    throw 'MessageUtil error'
  })
}
/**
 * @typedef Message
 * @property {string} from one of 'fo-online' 'template-plugin'
 * @property {string} type one of 'response' 'request'
 * @property {string} id (optional)
 * @property {string} method (optional)
 * @property {object} data
 */

export class MessageUtil{
  constructor(isDebug){
    this.onRequestMethodFn = noOp;
    this.from = '';
    this.cacheMap = {};
    this.eventMap = {};
    this.targetOrigin = '*';
    this.isDebug = isDebug;

    window.__ai_plugin__ = window.__ai_plugin__ || {};
    window.__ai_plugin__['event_map'] = this.eventMap;
    window.__ai_plugin__['event_cache_map'] = this.cacheMap;

    this.init = this.init.bind(this);
    this.onRequest = this.onRequest.bind(this);
    this.onResponse = this.onResponse.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.doSendResponse = this.doSendResponse.bind(this);
    this.onEvent = this.onEvent.bind(this);
  }

  init(onRequestMethodFn, from, targetOrigin){
    this.from = from;
    targetOrigin && (this.targetOrigin = targetOrigin)
    this.onRequestMethodFn = onRequestMethodFn;

    if(!window.parent||!window.parent.postMessage || window.parent === window){
      if(!this.isDebug)throw 'window.parent error'
      //return;
    }
    let _this = this;
    window.addEventListener("message", (event)=>{
      //console.log("TCL: template-plugin, message -> event", event, "this.targetOrigin:", _this.targetOrigin)
      if(`${event.origin}` !== _this.targetOrigin){
        return;
      }
      let message = event.data;
      // response
      if (message.type === MESSAGE_TYPE.RESPONSE) {
        // console.log('TCL: template-plugin, on message RESPONSE -> message.online -> event.data:', event, message)
        this.onResponse(message);
        return;

      }
      // request to do something
      if (message.type === MESSAGE_TYPE.REQUEST) {
        console.log('TCL: template-plugin, on message REQUEST -> message.online -> event.data:', event, message)
        this.onRequest(message, event.source);
        return;
      }
      if (message.type === MESSAGE_TYPE.EVENT) {
        console.log('TCL: template-plugin, on message EVENT -> message.online -> event.data:', event, message)
        this.onEvent(message);
        return;
      }
    }, false);
  }

  onEvent(message){
    let id = message.id;
    let data = message.data;
    let calls = this.eventMap[id];
    if(calls && calls.resolve){
      delete this.cacheMap[id];
      calls.resolve(data)
      return;
    }
    throw 'error'
  }

  onRequest(message, source) {
    const {method, data, id} = message;
    this.onRequestMethodFn(method, data, id).then((result)=>{
      let message = {
        from: this.from,
        type: MESSAGE_TYPE.RESPONSE,
        id,
        method,
        data: result
      }
      // post to parent
      source.postMessage(message, this.targetOrigin)
    })
  }
  // receive message from listener
  onResponse(message){
    let id = message.id;
    let data = message.data;
    let calls = this.cacheMap[id];
    if(calls && calls.resolve){
      delete this.cacheMap[id];
      calls.resolve(data)
      return;
    }
    console.log('onResponse error')
  }
  // send response to other window
  doSendResponse(method, data, id){
    let message = {
      from: this.from,
      type: MESSAGE_TYPE.REQUEST,
      id,
      method,
      data
    }
    window.parent.postMessage(message, this.targetOrigin)
  }

  /*
  * @param {string} method
  * @param {object} data
  * @returns {Promise.<Object>} result
  */
  handleMessage(method, data, onEvent) {
    return new Promise((resolve, reject)=>{

      if(window.parent === window){
        resolve({ret:10000})
        return;
      }
      let id = cuid();
      let type = MESSAGE_TYPE.REQUEST;
      if(method === 'subscribe' ){//'__dispatchEvent'
        type = MESSAGE_TYPE.LISTENER
        this.eventMap[id] = { method, resolve: onEvent, reject }
      }else {
        this.cacheMap[id] = { method, resolve, reject }
      }

      let message = {
        from: this.from,
        type,
        id,
        method,
        data
      }
      if(window.parent/*  && window.parent.origin === this.targetOrigin */){
        window.parent.postMessage(message, this.targetOrigin)
        return;
      }
      //window.postMessage(message, '*')
    })

  }

}

